import { render, staticRenderFns } from "./formulator-slider.vue?vue&type=template&id=19427e3e&"
import script from "./formulator-slider.vue?vue&type=script&lang=js&"
export * from "./formulator-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports